window.addEventListener('DOMContentLoaded', () => {
	const divs = document.querySelectorAll('.testimonials .rte');

	divs.forEach((myDiv) => {
		// Check if the button has already been added to the div
		if (!myDiv.parentNode.querySelector('.show-more-button')) {
			if (myDiv.scrollHeight > myDiv.clientHeight) {
				const myButton = document.createElement('button');
				myDiv.parentNode.classList.add('show');
				// myButton.textContent = 'Show More';
				myButton.classList.add('show-more-button');
				myButton.addEventListener('click', () => {
					myDiv.classList.toggle('show');
					myButton.classList.toggle('show');
				});
				myDiv.parentNode.appendChild(myButton);
			}
		}
	});
})